module.exports = __webpack_public_path__ + "static/media/img.ba9ca48c.png";